var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoginIcon = function SvgLoginIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 17,
    fill: "none",
    viewBox: "0 0 18 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 8.5c2.302 0 4.167-1.79 4.167-4S11.302.5 9 .5s-4.167 1.79-4.167 4 1.865 4 4.167 4m0 2c-2.781 0-8.333 1.34-8.333 4v2h16.666v-2c0-2.66-5.552-4-8.333-4"
  })));
};
export { SvgLoginIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxOCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMDAwMDggOC41QzExLjMwMjIgOC41IDEzLjE2NjcgNi43MSAxMy4xNjY3IDQuNUMxMy4xNjY3IDIuMjkgMTEuMzAyMiAwLjUgOS4wMDAwOCAwLjVDNi42OTggMC41IDQuODMzNDIgMi4yOSA0LjgzMzQyIDQuNUM0LjgzMzQyIDYuNzEgNi42OTggOC41IDkuMDAwMDggOC41Wk05LjAwMDA4IDEwLjVDNi4yMTg4MyAxMC41IDAuNjY2NzQ4IDExLjg0IDAuNjY2NzQ4IDE0LjVWMTYuNUgxNy4zMzM0VjE0LjVDMTcuMzMzNCAxMS44NCAxMS43ODEzIDEwLjUgOS4wMDAwOCAxMC41WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";